PJQ.views.bidForms.Settings = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Settings'),
		subTemplates: {},
		maxWidth: 500,
		overrideLockDate: false,
		onChange: null,
		isDefaultSettings: null
	},
	events: {
		'click .cb-bid-leveling': 'bidLevelingChanged',
		'click .settings-save': 'onSave',
		'change .input-override-lock-date': 'overrideLockChanged',
		'change .cb-use-bid-packages': 'useBidPackagesChanged'
	},
	beforeFirstRender: function () {
		new PJQ.Loader(this.$('.modal-body'));
		if (this.model != null) {
			if (_.size(this.model.get('defaultLineItemDescription')) === 0)
				this.model.set('defaultLineItemDescription','Base Bid');

			this.fetchProjectCustomFields(_.bind(function () {
				this.render();
			}, this))
		}
		else {
			this.fetchSettings(_.bind(function () {
				this.fetchProjectCustomFields(_.bind(function () {
					this.render();
				}, this))
			}, this))
		}
	},
	fetchSettings: function (callback) {
		let fnCallback = _.bind(function (settings) {
			this.model = settings;
			if (_.size(this.model.get('defaultLineItemDescription')) === 0)
				this.model.set('defaultLineItemDescription','Base Bid');

			if (typeof callback === 'function') {
				callback();
			}
		}, this);
		if (this.options.project != null) {
			this.options.project.fetchBidFormSettings(fnCallback);
		}
		else {
			PJQ.app.session.fetchBidFormSettings(fnCallback);
		}
	},
	fetchProjectCustomFields: function (callback) {
		let fnCallback = _.bind(function (customFields) {
			this.options.dateCustomFields = customFields.filter(function (customField) {
				return customField.get('fieldType') === PJQ.constants.customFields.fieldTypes.DATE
					|| customField.get('fieldType') === PJQ.constants.customFields.fieldTypes.DATETIME;
			});
			if (typeof callback === 'function') {
				callback();
			}
		}, this);
		if (this.options.project != null) {
			this.options.project.fetchProjectCustomFields(fnCallback);
		}
		else {
			PJQ.app.session.fetchProjectCustomFields(null, fnCallback);
		}
	},
	renderData: function () {
		return {
			model: this.model,
			dateCustomFields: this.options.dateCustomFields,
			overrideLockDate: this.options.overrideLockDate
		};
	},
	overrideLockChanged: function () {
		this.options.overrideLockDate = !this.options.overrideLockDate;
		this.render();
	},
	useBidPackagesChanged: function () {
		let $cbUseBidPackages = this.$('.cb-use-bid-packages'),
			useBidPackages = $cbUseBidPackages.prop('checked'),
			fnAfterChange = _.bind(function() {
				if (useBidPackages) {
					this.model.set('isAddDefaultLineItem', false);
					this.$('.cb-add-default-lineitem').prop('checked', false).prop('disabled', true);
				}
				else {
					// enable auto line items control
					this.$('.cb-add-default-lineitem').prop('disabled', false);
				}

				this.render();
			}, this);

		if (this.options.project != null) {
			let confirmHeader,
				confirmBody;
			if (useBidPackages) {
				confirmHeader = "Switch to Bid Packages Bid Forms?";
				confirmBody = "Enabling Bid Package Bid Forms will remove any <b>Trade Bid Forms and related Proposals</b> currently on this project.  This will also move related Line Items, Alternates, and Acknowledgements to the new corresponding Bid Package Bid Form if existing. Are you sure you would like to switch to using Bid Package Bid Forms?";
			}
			else {
				confirmHeader = "Switch to Trade Bid Forms?";
				confirmBody = "Disabling Bid Package Bid Forms will switch this project to Trade Bid Forms and remove all <b>Bid Package Proposals</b> currently on this project. Are you sure you would like to switch to using Trade Bid Forms?";
			}
			new PJQ.views.modals.YesNo({
				header: confirmHeader,
				body: confirmBody,
				onYes: _.bind(function() {
					fnAfterChange();
				}, this),
				onNo: _.bind(function () {
					useBidPackages = !useBidPackages;
					this.model.set('isUsingBidPackages', useBidPackages);
					$cbUseBidPackages.prop('checked', useBidPackages);
					fnAfterChange();
				}, this)
			});
		} else {
			fnAfterChange();
		}

	},
	bidLevelingChanged: function () {
		if (this.options.project != null && this.$('.cb-bid-leveling').prop('checked')) {
			let confirmBody = "Are you sure you want to enable bid leveling?<br /><strong>Note:</strong> ";
			if (this.options.project != null) {
				confirmBody += "Enabling bid leveling on this project will prevent bidders from creating their own line items and alternates.  Any submitted bid on this project with line items or alternates created by the bidder will be marked as rejected.";
			}
			else {
				confirmBody += "Enabling bid leveling system-wide will prevent bidders from creating their own line items and alternates.  This will not enable bid leveling on projects that already contain submitted bids with line items or alternates created by the bidder.";
			}
			new PJQ.views.modals.YesNo({
				header: "Enable Bid Leveling?",
				body: confirmBody,
				onNo: _.bind(function () {
					this.model.set('isBidLevelingEnabled', false);
					this.$('.cb-bid-leveling').prop('checked', false);
				}, this)
			});
		}
	},
	onChange: function () {
		if (this.model.get('isAddDefaultLineItem') && _.size(this.model.get('defaultLineItemDescription')) ==0) {
			this.model.set('defaultLineItemDescription','Base Bid');
		}

		if (typeof this.options.onChange === 'function') {
			this.options.onChange(this.model);
		}
	},
	/*
	validateSettings: function() {
		let result = true;
		if (this.model.get('isAddDefaultLineItem')) {
			PJQ.helpers.inputHelpers.setInputError(this.$('.input-description'), true);

			result = _.size(this.model.get('defaultLineItemDescription')) > 0;

			if (!result)
				PJQ.helpers.inputHelpers.setInputError(this.$('.input-description'));
		}

		return result;
	},
	 */
	afterRender: function () {
		if (this.model && this.model.isFetched) {
			new PJQ.Binder(this.$el, this.model, {
				watchElements: [
					'input',
					'textarea'
				],
				afterChange: _.bind(function (changeEl, attribute) {
					if (attribute === 'isAllowLateBids' || attribute === 'isAddDefaultLineItem') {
						this.render();
					}
					if (attribute === 'isAutoExportProposals') {
						if (!this.model.get('isAutoExportProposals'))
							this.model.set('isExportProposalsByTrade', false);

						this.render();
					}
					if (attribute === 'isExportProposalsByTrade') {
						if (this.model.get('isExportProposalsByTrade'))
							this.model.set('isAutoExportProposals', true);

						this.render();
					}
					this.onChange();
				}, this)
			});

			if (this.options.isDefaultSettings) {
				this.$('.bid-form-settings-header').text('Default Bid Form Settings');
				this.$('.bid-form-settings-info').removeClass('hidden');
			}

			if (this.options.overrideLockDate) {
				new PJQ.inputs.Datepicker({
					el: this.$('.input-lock-date'),
					isShowTimezone: false,
					datepickerOptions: {
						defaultDate: this.model.get('lockDate') != null ? new Date(this.model.get('lockDate')) : null
					},
					onChange: _.bind(function () {
						this.onChange();
					}, this)
				});
			}
			else {
				let cf = this.model.get('lockDateCustomField');
				new PJQ.inputs.Selectpicker({
					el: this.$('.select-lock-source'),
					defaultValue: cf != null ? ('cf_' + cf.toString()) : 'BIDS_DUE',
					onChange: _.bind(function (value) {
						this.model.set('lockDateCustomField', value === 'BIDS_DUE' ? null : parseInt(value.replace('cf_', '')));

						this.onChange();
					}, this)
				});
			}

			new PJQ.views.files.FileUploaderGrid({
				el: this.$('.bid-documents-file-upload'),
				collection: this.model.additionalBidDocuments,
				onDrop: _.bind(function () {
					this.onChange();
				}, this),
				onDelete: _.bind(function (file, callback) {
					file.set('isDeleted', true);
					callback();

					this.onChange();
				}, this)
			});
		}
	}
});

PJQ.views.bidForms.BidFormSettingsModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Modal-Bid-Form-Settings'),
		minWidth: "600px",
	},
	events: {
		'click .settings-save': 'onSave'
	},
	afterRender: function () {
		this.settingsView = new PJQ.views.bidForms.Settings({
			el: this.$('.modal-body'),
			model: this.model,
			project: this.options.project
		});
	},
	onSave: function () {
		/* We can't reliably call this from the global Settings.
		if (!this.settingsView.validateSettings())
			return;

		 */

		//We have to be sure we save te project and the daily report settings before we callback to onSave
		//The onSave is likely waiting to get a new list of reports to refresh their statuses
		let loader = new PJQ.Loader(this.$('.modal-content'));
		this.settingsView.model.save(null, {
			success: _.bind(function () {
				PJQ.notifications.notify.successNotify({
					message: 'Bid forms settings saved'
				});
				if (typeof this.options.onSave === 'function') {
					this.options.onSave();
				}
				this.removeModal();
			}, this),
			error: function () {
				loader.remove();
			}
		});
	}
});